export default class AfpUserServiceContact
	{
		public cedula: string = "";
		public contacts: Array<UserContact> = [];
	}
	export class UserContact
	{
		public cedula: string = "";
		public idSec: string = "";
		public parentesco: string = "";
		public nombre: string = "";
		public direccion: string = "";
		public telefono: string = "";
		public email: string = "";
		public menor: string = "";
	}